export enum Permission {
    Mpc,
    Avvik,
    Statistics
}
